import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import mqtt_topics from "./../../../mqtt/mqtt_topics";
import "./../../../css/app.css";

const Led = (props) => {
  const mac = mqtt_topics.choosenmac; //"0-5b-96";
  const [state, setState] = useStateIfMounted({
    value: false,
    title: props.title, //"Led UI"
    label: "---",
    fct: undefined,
    loading: false,
  });
  const target_live_reading_topic =
    mqtt_topics.fixed_topic_part +
    mac +
    "/" +
    props.category +
    mqtt_topics.Readings_topic +
    state.title;

  function listenforlivedata() {
    //console.log("target_live_reading_topic " + target_live_reading_topic);
    props.mqttClient.subscribe(target_live_reading_topic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function requesttochangeled(which_output) {
    props.mqttClient.publish(
      mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
      JSON.stringify({
        fct: state.fct,
        label: which_output,
      })
    );
    //'{"fct":"' + state.fct + '","label": "' + which_output + '"}'
    setState({
      ...state,
      loading: true,
    });
  }

  function handleMqttMessage(topic, message) {
    if (topic == target_live_reading_topic) {
      try {
        // message is Buffer
        //console.log(topic, "From Surf Mode: " + message.toString());
        message = JSON.parse(message.toString());
        setState({
          ...state,
          value:
            message.value == undefined
              ? false
              : message.value == 0
              ? false
              : true,
          label: message.label == undefined ? "---" : message.label,
          fct: message.fct,
        });
      } catch (error) {
        //console.log(message);
      }
    }
  }

  useEffect(() => {
    listenforlivedata();
  }, []);

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(target_live_reading_topic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  if (state.fct != undefined) {
    let buttonImagename =
      state.fct == "ActivateOp" ? "normalButton" : "butten_led";
    return (
      <div className="col">
        <div className="card text-center bg-light ledcard">
          <div className="card-header">{state.title}</div>
          <div className="card-body">
            <img
              className="buttonledimage"
              style={{ display: state.loading ? "none" : "block" }}
              src={
                state.value
                  ? require("./../../../images/led/" +
                      buttonImagename +
                      "_on.png")
                  : require("./../../../images/led/" +
                      buttonImagename +
                      "_off.png")
              }
              onClick={() => {
                // Perform an action on click
                requesttochangeled(state.label);
              }}
            />
            <div
              className="spinner-border text-primary"
              style={{ display: state.loading ? "block" : "none" }}
            ></div>
            <br />
            <small className="text-muted bg-transparent">{state.label}</small>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="col">
        <div className="card text-center bg-light ledcard">
          <div className="card-header">{state.title}</div>
          <div className="card-body">
            <img
              className="ledimage"
              src={
                state.value
                  ? state.title == "RC"
                    ? require("./../../../images/diagram/normal/green_onIndicator.png")
                    : require("./../../../images/diagram/normal/red_onIndicator.png")
                  : state.title == "RC"
                  ? require("./../../../images/diagram/normal/green_offIndicator.png")
                  : require("./../../../images/diagram/normal/red_offIndicator.png")
              }
            />
            <br />
            <small className="text-muted bg-transparent">{state.label}</small>
          </div>
        </div>
      </div>
    );
  }
};
export default Led;
